module.exports = __webpack_public_path__ + "static/media/16UNODC24.fab39d8a.jpg";